export const mediaKits = [
  {
    id: "gamejam",
    title: "GameJam",
    eyebrow: "Creator Arena",
    description: "CGES GameJam assets, posters, and social graphics.",
    accent: "secondary",
    icon: "fa-solid fa-bolt",
    badge: "Live Now",
    cta: "open kit",
    islive:true,
    downloadurl: "https://d2r5hrlw4m5nor.cloudfront.net/media_kit/gamejam/CGES_GameJam_April_2026.zip",
    slug: "April2026",
    assets: [
      {
        id: "gamejam-poster",
        name: "CGES GameJam April-2026",
        type: "File",
        preview: "/assets/img/mediakit/gamejam/gamejam.png",
        download: "https://d2r5hrlw4m5nor.cloudfront.net/media_kit/gamejam/CGES_GameJam_April_2026.zip",
      },
      // {
      //   id: "gamejam-poster",
      //   name: "CGES GameJam 2026",
      //   type: "Image",
      //   preview: "/assets/img/mediakit/gamejam/gamejam.png",
      //   download: "/assets/img/mediakit/gamejam/gamejam.png",
      // },
      // {
      //   id: "gamejam-poster",
      //   name: "Event Poster",
      //   type: "PDF",
      //   preview: "/assets/img/mediakit/gamejam/gamejam.png",
      //   download: "https://example.com/gamejam/poster.pdf",
      // },
      // {
      //   id: "gamejam-promo",
      //   name: "Promo Video",
      //   type: "Video",
      //   preview: "https://example.com/gamejam/promo.mp4",
      //   download: "https://example.com/gamejam/promo.mp4",
      // },
    ],
  },
  // {
  //   id: "emagnize",
  //   title: "e-Magnize",
  //   eyebrow: "Insider Drops",
  //   description: "CGES Magazine cover templates, logo lockups, and promo banners.",
  //   accent: "tertiary",
  //   icon: "fa-solid fa-book-open-reader",
  //   badge: "Ready",
  //   cta: "Open Kit",
  //   islive:false,
  //   downloadurl: "https://example.com/emagnize/CGES_EMagnize_April_2026.zip",
  //   slug: "April2026",
  //   assets: [
  //     // {
  //     //   id: "emagnize-logo",
  //     //   name: "Logo Primary",
  //     //   type: "Image",
  //     //   preview: "https://via.placeholder.com/640x400.png?text=eMagnize+Logo",
  //     //   download: "https://example.com/emagnize/logo.png",
  //     // },
  //     // {
  //     //   id: "emagnize-cover",
  //     //   name: "Cover Template",
  //     //   type: "Image",
  //     //   preview: "https://example.com/emagnize/cover-template.pdf",
  //     //   download: "https://example.com/emagnize/cover-template.pdf",
  //     // },
  //     // {
  //     //   id: "emagnize-banner",
  //     //   name: "Promo Banner",
  //     //   type: "Image",
  //     //   preview: "https://via.placeholder.com/900x420.png?text=eMagnize+Banner",
  //     //   download: "https://example.com/emagnize/banner.png",
  //     // },
  //     // {
  //     //   id: "emagnize-trailer",
  //     //   name: "Launch Trailer",
  //     //   type: "Video",
  //     //   preview: "https://example.com/emagnize/trailer.mp4",
  //     //   download: "https://example.com/emagnize/trailer.mp4",
  //     // },
  //   ],
  // },
];

export const getMediaKitById = (kitId) =>
  mediaKits.find((kit) => kit.id === kitId);
